export default function () {
  const config = useRuntimeConfig()

  const loc = new URL(config.public.craAppUrl).hostname.split('.')

  loc.unshift('')

  const identity = useCookie<false | {
    isTemp: boolean,
    email: string,
    name: string,
    firstname: string,
    lastname: string,
    signature?: string
    companies: any[]
  }>('identity', {
    default: () => false,
    domain: loc.join('.'),
    secure: true,
    maxAge: 60 * 60 * 24 * 365 * 10 // 10 ans en secondes
  })

  const authentity = useCookie<false | string>('sessionKey', {
    default: () => false,
    domain: loc.join('.'),
    secure: true,
    maxAge: 60 * 60 * 24 * 365 * 10 // 10 ans en secondes
  })
  
  const identify = (value: any) => {
    identity.value = value
  }

  const authenticate = async (sessionId?: string) => {
    if (sessionId) {
      authentity.value = sessionId
    } else {
      if (identity.value) {
        const res: {
          sessionId: string
        } = await $fetch(`${config.public.apiBaseUrl}/connexion`, {
          method: 'POST',
          body: {
            email: identity.value.email,
          }
        })
    
        authentity.value = res.sessionId
      }
    }
  }

  const synchronizeAuthAndIdent = async (withoutPictures: boolean, mounted: boolean) => {
    if (authentity.value) {
      const url = `${config.public.apiBaseUrl}/me?withoutPictures=${withoutPictures}&auth_token=${authentity.value}`
      try {
        let me
        if (mounted) {
          me = await $fetch(url)
        } else {
          const res = await useFetch(url)
          if (res.error.value) {
            throw new Error('Auth Error')
          }
          me = res.data.value
        }
        identify(me)
      } catch (e) {
        authentity.value = false
        identity.value = false
      }
    }
  }

  const resetIdentity = async () => {
    if (authentity.value) {
      try {
        await $fetch(`${config.public.apiBaseUrl}/session?auth_token=${authentity.value}`, {
          method: 'DELETE'
        })
      } catch (e) {
        console.error(e)
      }
      
      authentity.value = false
    }
    identity.value = false
  }

  return {
    authenticate,
    resetIdentity,
    identify,
    identity,
    authentity,
    synchronizeAuthAndIdent
  }
}